import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography } from '@mui/joy';
import BillCard from '../BillCard/BillCard';
import './RelatedBills.css'

function RelatedBills({relatedBills}) {
  return (
    <Stack direction={"column"} spacing={4} padding={4} sx={{ marginTop: 4 }}>
      <Typography level="h2" sx={{ fontWeight: 'bold' }}>
        Related Bills
      </Typography>
      <div className="bill-list">
        {relatedBills ? relatedBills.map((bill, index) => (
            <BillCard key={index} bill={bill} />
        )) : null }
        </div>
    </Stack>
  );
};
  
// Prop types for our Component
RelatedBills.propTypes = {
    relatedBills: PropTypes.object.isRequired,
}

export default RelatedBills;